import Axios from "axios";
import { getEnvVar } from "ideas.env";
import { getRequestHeaders } from "utils/getRequestHeaders";

export const createPersonalSpaceDjango = async (syncHomeRegion: boolean) => {
  const headers = await getRequestHeaders();
  const data = await Axios.post<{ id: number }>(
    getEnvVar("URL_TENANT_USERS_PERSONAL_SPACE"),
    { synchronize_home: syncHomeRegion },
    { headers },
  );
  return data;
};
